<template>
  <form class="product_form" @submit.prevent="emitSave" id="productTableAddEditDialog">
    <h4 class="mb-4">{{ "ADD" | translate }}</h4>
    
    <div class="form-group" id="productTableAddEditDialog-formGroup-Productnaam">
      <label
        >{{ "Productnaam" | translate }} <span class="asterisk">*</span></label
      >
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="product.name"
        required
        :disabled="Boolean(edited)"
        id="productTableAddEditDialog-formGroup-Productnaam-input"
      />
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-Omschrijving">
      <label>{{ "Omschrijving" | translate }}</label>
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="product.description"
        id="productTableAddEditDialog-formGroup-Omschrijving-input"
      />
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-Maatschappij">
      <label>{{ "Maatschappij" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.insurerName"
        id="productTableAddEditDialog-formGroup-Maatschappij-select"
      >
        <option value="" :id="'productTableAddEditDialog-select-option-Maatschappij-'+ ' '"></option>
        <template v-for="insurer in insurers">
          <option :key="insurer.name" :value="insurer.name" :id="'productTableAddEditDialog-select-option-'+insurer.name">
            {{insurer.name}} - {{insurer.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-Branche">
      <label>{{ "Branche" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.productLineName"
        id="productTableAddEditDialog-formGroup-Branche-select"
      >
        <option value="" :id="'productTableAddEditDialog-select-option-branche-'+ ' '"></option>
        <template v-for="productline in productlines">
          <option :key="productline.name" :value="productline.name" :id="'productTableAddEditDialog-select-option-'+productline.name">
            {{productline.name}} - {{productline.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-PremieberekeningVia">
      <label>{{ "Premieberekening" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.premieberekeningVia" @change="handleVpi"
        id="productTableAddEditDialog-formGroup-PremieberekeningVia-select"
      >
          <option value="VPI" id='productTableAddEditDialog-select-option-PremieberekeningVia' >
            VPI
          </option>
          <option value="LEVEL" id='productTableAddEditDialog-select-option-PremieberekeningVia' >
            Level
          </option>
          <option value="NONE" id='productTableAddEditDialog-select-option-PremieberekeningVia' >
            {{ 'NONE' | translate }}
          </option>
      </select>
    </div>

    <div>
    <div v-if="product.premieberekeningVia === 'VPI'" class="form-group" id="productTableAddEditDialog-formGroup-ProductId">
      <label>{{ "ProductId" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.productId"
        id="productTableAddEditDialog-formGroup-ProductId-input"
        :disabled="uniqueGimObjects.length === 1"
      >
      <option value="" :id="'productTableAddEditDialog-select-option-ProductId'"></option>
        <template v-for="gimobject in uniqueGimObjects">
          <option :key="gimobject.productName" :value="gimobject.productName" :id="'productTableAddEditDialog-select-option-'+gimobject.productName">
            {{gimobject.productName}}
          </option>
        </template>
      </select>
    </div>
  </div>

      <div v-if="product.premieberekeningVia === 'VPI'" class="form-group" id="productTableAddEditDialog-formGroup-ContextId">
      <label>{{ "ContextId" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.contextId"
        id="productTableAddEditDialog-formGroup-ContextId-input"
        :disabled="filteredContexts.length === 1"
      >
        <option value="" :id="'productTableAddEditDialog-select-option-ContextId'"></option>
        <template v-for="(contextId, index) in filteredContexts" >
          <option :key="index" :value="contextId" :id="'productTableAddEditDialog-select-option-' + contextId">
            {{ contextId }}
          </option>
        </template>
      </select>
    </div>
    <div v-if="product.premieberekeningVia === 'VPI'" class="form-group" id="productTableAddEditDialog-formGroup-FunctionId">
      <label>{{ "FunctionId" | translate }}</label>
      <select
        type="text"
        class="form-control form-control-sm"
        v-model="product.functionId"
        id="productTableAddEditDialog-formGroup-FunctionId-input"
        :disabled="filteredfunctionIds.length === 1"
      >
        <option value="" :id="'productTableAddEditDialog-select-option-FunctionId'"></option>
        <template v-for="(functionId, index) in filteredfunctionIds" >
          <option :key="index" :value="functionId" :id="'productTableAddEditDialog-select-option-' + functionId">
            {{ functionId }}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-NoClaimsDiscountTable">
      <label>{{ "NoClaimsDiscountTable" | translate }}</label>
      <select
        class="form-control form-control-sm"
        v-model="product.noClaim"
        id="productTableAddEditDialog-formGroup-NoClaimsDiscountTable-select"
      >
        <option value="" :id="'productTableAddEditDialog-select-option-NoClaimsDiscountTable-'+ ' '"></option>
        <template v-for="noClaimDiscountTable in sortedNoClaimsDiscountTable">
          <option :key="noClaimDiscountTable.code" :value="noClaimDiscountTable.code" :id="'productTableAddEditDialog-select-option-'+noClaimDiscountTable.description">
            {{noClaimDiscountTable.description}}
          </option>
        </template>
      </select>
    </div>

    <div class="form-group" id="productTableAddEditDialog-formGroup-Covers" v-if="product.covers && product.covers.length">
  <label>{{ "COVERS" | translate }}</label>
  <div style="max-height: 100px; overflow-y: auto; border: 1px solid #ccc; padding: 5px;">
    <div v-for="cover in product.covers" :key="cover.code" class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        :id="'cover-checkbox-' + cover.code"
        v-model="cover.enabled"
      />
      <label class="form-check-label" :for="'cover-checkbox-' + cover.code">
        {{ cover.description }}
      </label>
    </div>
  </div>

</div>


    <div class="form-group" id="productTableAddEditDialog-formGroup-Enabled">
      <label>{{ "Enabled" | translate }}</label>
    <input type="checkbox"
           class="form-control form-control-sm"
           v-model="product.enabled"
           id="productTableAddEditDialog-formGroup-Enabled-input">
    </div>

    <div class="mt-4 text-right" id="productTableAddEditDialog-formGroup-buttons">
      <button class="btn btn-link" type="button" @click="emitClose"
      id="productTableAddEditDialog-closeButton">
        {{ "CLOSE" | translate }}
      </button>

      <button class="btn btn-primary" type="submit" :disabled="!isFormValid"
      id="productTableAddEditDialog-addButton">
        {{ "ADD" | translate }}
      </button>
    </div>
  </form>
</template>

<script>

export default {
  props: ['edited', 'productlines', 'insurers', 'gimobjects', 'noClaimsDiscountTable'],
  data() {
    return {
      product: {}
    };
  },
  computed: {
    isFormValid() {
      return this.product.name;
    },
    sortedNoClaimsDiscountTable() {
      return [...this.noClaimsDiscountTable].sort((a, b) =>
      a.description.localeCompare(b.description)
    );
    },
    uniqueGimObjects() {
      // Ensure productName is unique
      const uniqueProductNames = {};
      return this.gimobjects.filter(gimobject => {
        if (!uniqueProductNames[gimobject.productName]) {
          uniqueProductNames[gimobject.productName] = true;
          return true;
        }
        return false;
      });
    },
    filteredContexts() {
      const filtered = this.gimobjects
        .filter(gimobject => gimobject.productName === this.product.productId);
      const uniqueContexts = [...new Set(filtered.map(gimobject => gimobject.contextId))];
      return uniqueContexts;
    },
    filteredfunctionIds() {
      if (!this.gimobjects || this.gimobjects.length === 0) {
        return this.product.functionId ? [this.product.functionId] : [];
      }
      if (!this.product.productId || !this.product.contextId) {
        return this.product.functionId ? [this.product.functionId] : [];
      }
      const filtered = this.gimobjects.filter(gimobject => {
        const productMatch = gimobject.productName === this.product.productId;
        const contextMatch = gimobject.contextId === this.product.contextId;
        return productMatch && contextMatch;
      });
      const uniquefunctionIds = [...new Set(filtered.map(gimobject => gimobject.functionId))];
      return uniquefunctionIds.length > 0 ? uniquefunctionIds : [this.product.functionId];
    }
  },
  methods: {
    emitSave() {
      this.$emit(this.edited ? 'update' : 'save', this.product);
      this.product = {};
    },
    emitClose() {
      this.$emit('close');
      this.product = {};
    },
    handleVpi() {
      this.$emit('updateProductLine', this.product.productLineName);
      this.$emit('updateInsurer', this.product.insurerName);
    }
  },
  watch: {
    edited(newVal, oldVal) {
      this.product = {...newVal};
    },
    filteredfunctionIds(newVal) {
      if (newVal.length === 1) {
        this.product.functionId = newVal[0];
      }
    },
    filteredContexts(newVal) {
      if (newVal.length === 1) {
        this.product.contextId = newVal[0];
      }
    },
    uniqueGimObjects(newVal) {
      if (newVal.length === 1) {
        this.product.productId = newVal[0].productName;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>> .vdp-datepicker__calendar {
  bottom: 30px;
}

.product_form{
  overflow-y: auto;
  max-height: 573px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/product/ProductAddEditDialog.vue